import { useState, useCallback } from 'react';
import update from 'immutability-helper';
import { nanoid } from 'nanoid';
import { useInputNew } from '@UI/InputNew/useInputNew';

export const useRegularity = (
    { 
        setIsChange = () => {}, 
        placeholderByChoosingTheTypeOfRegularity = 'Регулярность',
        availableFields = {
            daily: true,
            monthly: true,
            annually: true,
            manually: false
        },
        initialRegularityType = 'daily',
        initRegularityForType = false, //передаем сюда данные только для определенного типа, остальные берем по умолчанию
        timeRange = false
    } = {}
) => {
    const [regularityType, setRegularityType] = useState(initialRegularityType);

    const allOptions = [
        { label: 'Ежедневно', value: 'daily' },
        { label: 'Ежемесячно', value: 'monthly' },
        { label: 'Ежегодно', value: 'annually' },
        { label: 'Вручную', value: 'manually' },
    ];
    
    const filteredOptions = allOptions.filter(option => availableFields[option.value]);

    const [bindRegularityType] = useInputNew({
        placeholder: placeholderByChoosingTheTypeOfRegularity,
        options: filteredOptions,
        newDesign: true,
        value: regularityType,
        onChange: (e) => {
            setIsChange(true)
            setRegularityType(e)
        },
    })

    const timeRangeFields = {
        hourEnd: 10,
        minutesEnd: 0,
    }

    const commonFieldsDaily = {
            active: false,
            hour: 10,
            minutes: 0,
            ...(timeRange && timeRangeFields)
    };

    const initRegularity = {
        daily: [
                    {
                        day: 1,
                        label: 'Понедельник',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 2,
                        label: 'Вторник',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 3,
                        label: 'Среда',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 4,
                        label: 'Четверг',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 5,
                        label: 'Пятница',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 6,
                        label: 'Суббота',
                        ...commonFieldsDaily,
                    },
                    {
                        day: 7,
                        label: 'Воскресенье',
                        ...commonFieldsDaily,
                    },
        ],
        monthly: [],
        annually: [],
        manually: {},
        ...(initRegularityForType && {[initialRegularityType]: initRegularityForType})//можем перезаписать сразу поле daily, или другое, если оно должно быть другим по умолчанию
    }

    const [regularity, setRegularity] = useState(initRegularity)

    const changeRegularity = useCallback(
        (index, value = '', firstField = 'daily', secondField = 'active') => {
        setIsChange(true)
        setRegularity((prev) => {
            return update(prev, {
            [firstField]: {
                [index]: {
                ...(secondField == 'active' && {
                    [secondField]: { $set: !prev.daily[index][secondField] },
                }),
                ...(secondField != 'active' && {
                    [secondField]: { $set: value },
                }),
                },
            },
            })
        })
        },
        [setRegularity, setIsChange],
    )

    const addRegularity = useCallback(
        (firstField) => {
        setIsChange(true)
        let newObg = {}
        switch (firstField) {
            case 'annually':
            newObg = {
                id: nanoid(),
                hour: 10,
                minutes: 0,
                number: 15,
                month: 1,
                ...(timeRange && timeRangeFields)
            }
            break
            case 'monthly':
            newObg = {
                id: nanoid(),
                hour: 10,
                minutes: 0,
                number: 15,
                ...(timeRange && timeRangeFields)
            }
            break
            case 'daily':
            newObg = {}
            break
        }

        setRegularity((prev) => {
            const currentArray = prev[firstField] || []
            return {
            ...prev,
            [firstField]: [...currentArray, newObg],
            }
        })
        },
        [setRegularity],
    )

    const deleteRegularity = useCallback(
        (index, firstField) => {
        setIsChange(true)
        setRegularity((prev) => {
            const currentArray = prev[firstField] || []
            return {
            ...prev,
            [firstField]: currentArray.filter(
                (el, indexIter) => indexIter != index,
            ),
            }
        })
        },
        [setRegularity],
    )

  return {
    setRegularityType,
    regularityType,
    bindRegularityType,

    regularity,
    setRegularity,
    changeRegularity,
    addRegularity,
    deleteRegularity

  };
};